import { createElement, Component, Props as ReactProps } from 'react';
import { DependencyProps } from '../../core/dependency';
import { LocationProps } from '../../core/location';
import { StateProps } from '../../core/state';
import RootFrame from '../components/templates/RootFrame';
import SignupForm from '../components/organisms/SignupForm';
import { Spin } from 'antd';
import styled from 'styled-components';
import SignupUser from '../../entity/signupUser';
import Store from "../../entity/store";

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps;

const StyledSpin = styled(Spin)`
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
`;

class SignupRoute extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.signup = this.signup.bind(this);
    this.updateSignupUserField = this.updateSignupUserField.bind(this);
  }

  public componentWillMount() {
    this.initialize(this.props);
  }

  public componentWillUnmount() {
    this.props.dependency.signup.dispose();
  }

  public render() {
    const { dependency, location, state } = this.props;
    const { user } = state.signup;

    const form = user ? (
      <SignupForm
        signupUser={user}
        onClickSignupButton={this.signup}
        updateSignupUserField={this.updateSignupUserField}
      />
    ) : (
      <StyledSpin />
    );

    return <RootFrame {...{ dependency, location, state }} content={form} />;
  }

  public async signup() {
    const store = this.props.state.currentStore as Store;
    await this.props.dependency.signup.signup();
    window.location.href = store.signinUri;
  }

  private initialize(props: Props) {
    try {
      props.dependency.signup.initialize();
    } catch (err) {
      window.console.error(err);
    }
  }

  private updateSignupUserField(partial: Partial<SignupUser>) {
    this.props.dependency.signup.updateSignupUserField(partial);
  }
}

export default SignupRoute;
